<template>
  <div class="vessel">
    <template>
      <el-alert title="病人信息" type="info" center :closable="false"></el-alert>
    </template>
    <el-form :inline="true" :model="formInline" class="demo-form-inline" style="margin:10px 0;">
      <el-form-item label="姓名">
        <el-input v-model="formInline.name" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="性别">
        <el-input v-model="formInline.gender" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="周岁">
        <el-input v-model="formInline.age" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="电话">
        <el-input v-model="formInline.phone" :disabled="true"></el-input>
      </el-form-item>
    </el-form>
    <template>
      <el-alert title="中药汤方" type="info" center :closable="false"></el-alert>
    </template>
    <el-collapse accordion>
      <el-collapse-item
              v-for="(item,index) in foldData"
              :key="index"
              :name="index"
              :title="item.recipeName"
      >
        <el-table :data="item.recipeItemResponses" border :row-class-name="tableRowClassName">
          <el-table-column type="index" width="auto"></el-table-column>
          <el-table-column align="center" prop="value" label="药品名称" width="auto"></el-table-column>
          <el-table-column align="center" label="数量" width="auto">
            <template slot-scope="scope">
              <el-input
                      size="small"
                      v-model="scope.row.number"
                      @change="numberchangeAccordion($event,scope.$index,index)"
                      placeholder="请输入内容"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="recordNumber" label="库存数量" width="auto"></el-table-column>
          <el-table-column align="center" prop="inventoryWarning" label="库存预警" width="auto"></el-table-column>
          <el-table-column align="center" prop="unit" label="单位" width="auto"></el-table-column>
          <el-table-column align="center" prop="retailPrice" label="单价" width="auto"></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                      @click.native.prevent="deleteRows(scope.$index, foldData,index)"
                      type="text"
                      size="small"
              >移除</el-button>
              <el-button v-if="scope.row.number != 0"
                         @click="substitute(scope.$index,scope.row,index)"
                         type="text"
                         size="small"
              >替换</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 弹出框 -->
        <el-dialog title="药品替换" :visible.sync="dialogFormVisible" width="35%"  >
          <template>
            <el-select v-model="val" placeholder="请选择替换的药品" @change="selectVariation(index)">
              <el-option
                      v-for="(item,index) in cfArr"
                      :key="index"
                      :label="item.value"
                      :value="item.id">
              </el-option>
            </el-select>
          </template>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click='sure'>确 定</el-button>
          </div>
        </el-dialog>

        <div class="add">
          <el-autocomplete
                  style="width:100%;"
                  v-model="rowDatas"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="请输入内容"
                  @select="handleSelects"
                  @click.native.prevent="location(index)"
          ></el-autocomplete>
        </div>

        <el-form :label-position="labelPosition" label-width="130px" style="margin-top:30px;">
          <el-form-item label="汤方名：">
            <el-input v-model="item.recipeName" placeholder="请输入汤方名" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="副数：">
            <el-input-number type="number" :min="1" v-model="item.quantity" :disabled="true"></el-input-number>
          </el-form-item>
          <el-form-item label="药袋价格：">
            <el-select v-model="item.bagsCost" placeholder="请选择" disabled>
              <el-option v-for="(item,index) in medicineBag" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="系数：">
            <el-input-number :precision="1" :min="1" v-model="item.coefficient" :disabled="true"></el-input-number>
          </el-form-item>
          <el-form-item label="煎服法：">
            <el-input v-model="item.eatType" placeholder="请输入煎服法" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="忌口及日常护理：">
            <el-input autosize type="textarea" placeholder="请输入忌口及日常护理" v-model="item.note" :disabled="true"></el-input>
          </el-form-item>
        </el-form>
        <div class="inOne-TabBttom">
          <el-button @click="preserveRemind(index)" type="warning">
            <i class="fa fa-floppy-o"></i>保存
          </el-button>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Aindex:'',
      OB:'',
      val:'',
      cfArr:[],       // 替换汤方数据
      dialogFormVisible: false,
      medicineBag:[
        {
          value: 14,
          label: '￥14'
        }, {
          value: 22,
          label: '￥22'
        }
      ],                        // 药袋
      indexV:0,                 // 表单下拉选择框
      labelPosition: "left",
      formInline: {
        name: "",
        gender: "",
        age: "",
        phone: ""
      },
      cid: 0,
      foldData: [],
      inx: 0,
      rowDatas: "",
      restaurants: [],               //  添加新列 - 数据
      thIndex:0,
      patientId:0,
      recipeItemId:0
    };
  },
  created() {
    let that = this;
    let transmitParams = that.$route.query;
    that.formInline = transmitParams.user;
    that.cid = transmitParams.cid;
    that.patientId = transmitParams.user.patientId;
    this.getcf(that.cid);
    this.newlyGain();               //  新增 行-数据
  },
  methods: {
    preserveRemind(){
      let recipeId = this.foldData[this.inx].recipeId;
      let that = this;
      let recipeItemResponses = that.foldData[this.inx].recipeItemResponses;

      for (let i = 0; i < recipeItemResponses.length; i++) {
            if (recipeItemResponses[i].number == 0) {
                that.$message({
                    type: "warning",
                    message: "请检查药品数量，序号：" + (i + 1)
                });
                return;
            }
        }
        let pair = that.foldData[this.inx].quantity;
        for (let j = 0; j < recipeItemResponses.length; j++) {
            let opportunity = pair * recipeItemResponses[j].number;     // 数量 乘机结果
            let inventory = recipeItemResponses[j].recordNumber;    // 库存数量
            let consequence = inventory - opportunity;
            if (consequence < 0) {
                that.$message({
                    type: "error",
                    message: "您的库存不足无法保存! 序号: " + (j + 1)
                });
                return;
            }
        }
        that
            .$confirm("确认保存吗？", "提示", {})
            .then(() => {
                that
                    .$axios({
                        url: "/api/inquiry/supplement/recipeItems/"+that.patientId+"/" + recipeId,
                        method: "POST",
                        data: that.foldData[this.inx].recipeItemResponses
                    })
                    .then(res => {
                        if(res.data.code == 200){
                            this.$message({
                                message: "保存成功",
                                type: "success"
                            });
                            //刷下数据
                            this.getcf(this.cid);
                        }else{
                            this.$message({
                                message: "保存失败",
                                type: "warning"
                            });
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            })
            .catch(err => {
                that.$message({
                    type: "info",
                    message: "已取消保存"
                });
            });
    },

    selectVariation(index){
      let tid = this.val;
      let cfArr = this.cfArr;
      let tindex = this.thIndex;
      let cObj;
      for(let i=0;i<cfArr.length;i++){
        if(cfArr[i].id == tid){
          cObj = cfArr[i];
          cObj.recordNumber = cfArr[i].recordNumber;
          cObj.number = 0;
          cObj.recipeItemId = this.recipeItemId;
          cObj.medicineId = cfArr[i].id;
        }
      }
      this.Aindex = index;
      this.OB = cObj

    },
    sure:function(){
      this.foldData[this.Aindex].recipeItemResponses.splice(this.thIndex,1,this.OB);
      this.dialogFormVisible=false;
      this.Aindex='';
      this.OB='';
      this.thIndex=0;
    },

    substitute(index,row,inx){
      let rowId = 0;
      this.recipeItemId = row.recipeItemId;
      if(row.id == undefined){
        rowId = row.medicineId;
      }else{
        rowId = row.id;
      }
      this.thIndex = index;
      let that = this;
      that
        .$axios({
          url: "/api/medicines/relations/" + rowId,
          method: "GET"
        })
        .then(res => {
          if(res.data.data.length == 0){
            this.dialogFormVisible = false;
            this.cfArr = [];
            this.val = '';
            that.$message({
              message: '没有可替换的数据',
              type: 'warning'
            });
          }else{
            this.dialogFormVisible = true;
            this.cfArr = res.data.data;
            this.val = '';
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 移除
    deleteRows(index, rows, inx) {
      this.foldData[inx].recipeItemResponses.splice(index, 1);
    },
    // 更改数量
    numberchangeAccordion(val, index, inx) {
      this.foldData[inx].recipeItemResponses[index].number = val;
    },
    getcf(mid) {
      this.$axios({
        url: "/api/inquiry/recipes/" + mid,
        method: "GET"
      })
        .then(res => {
          this.foldData = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    querySearchAsync(queryString, cb) {
      //  点击新增选择框
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      if (results.length == 0) {
        this.newlyGain(); //  获取 新增 行数据
        return;
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 1000 * Math.random());
    },
    handleSelects(item) {
      let inx = this.inx;
      let _data = {
        value: item.value, // 药品名称
        number: 0, // 数量
        recordNumber: item.recordNumber, // 库存数量
        retailPrice: item.retailPrice, // 单价
        unit: item.unit, // 单位
        id: item.id,
        medicineId: item.id,
        inventoryWarning:item.inventoryWarning      // 库存预警
      };
      this.rowDatas = "";
        let recipeItem = this.foldData[inx].recipeItemResponses;
        for (let i = 0; i < recipeItem.length; i++) {
            // 判断是否id重复
            if (recipeItem[i].medicineId == _data.id) {
                this.$message({
                    type: "error",
                    message: "药品已存在，请确认！序号:" + (i + 1)
                });
                return;
            }
        }
      this.foldData[inx].recipeItemResponses.push(_data);
    },
    location(index) {
      this.inx = index;
    },
    createStateFilter(queryString) {
      //  element-ui api生成数据接口
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    newlyGain() {
      //  获取新增列 - 数据
      this.$axios({
        url: "/api/medicines",
        method: "GET"
      })
        .then(res => {
          if (res.data.code == 200) {
            this.restaurants = res.data.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    tableRowClassName({row, rowIndex}) {
        if (row.recordNumber <= row.inventoryWarning) {
            return "warning-row";
        }
        return "";
    }
  }
};
</script>

<style type="text/css" scoped>
  .vessel {
    padding: 20px;
  }
  .add {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .inOne-TabBttom {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// compileC.vue?42367af0